@if (saveError) {
  <div class="container">
    <app-error-page></app-error-page>
  </div>
}
@if (showError) {
  <div class="alert-container">
    <div class="alert alert-success" role="alert">
      <mat-icon class="alert-icon" color="warn">error</mat-icon>
      <p class="alert-message">{{ 'error.link_expired' | translate }}</p>
    </div>
  </div>
}
@if (!showError && userCard) {
  <div class="cart-parent-single w-100 h-100">
    <div class="main-central-cart w-100">
      <button type="button" class="back-button" (click)="goBack()" aria-label="Back">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="#12314F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <div class="back-frame">
        <div class="back-frame-mini-1 w-100">
          <div class="back-frame-payment-mini-1-top">
            <img class="profile-pic-style"
                 [src]="userCard.profilePic ? getUserCardImage(userCard.id, ImageType.PROFILE_PIC) : 'assets/svg/defaultUserIcon.svg'"
                 alt="User default picture"/>

            <span class="username-in-frame">{{ userCard.name }} {{ userCard.surname }}
              @if (userCard.isBusiness) {
                <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="15" cy="15.2539" r="15" fill="#12314F"/>
                <mask id="mask0_9436_40359" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="6" y="6"
                      width="18" height="18">
                  <rect x="6" y="6" width="18" height="18" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_9436_40359)">
                  <path d="M8.99805 21.751C8.58555 21.751 8.23242 21.6041 7.93867 21.3104C7.64492 21.0166 7.49805 20.6635 7.49805 20.251V17.251H12.748V18.751H17.248V17.251H22.498V20.251C22.498 20.6635 22.3512 21.0166 22.0574 21.3104C21.7637 21.6041 21.4105 21.751 20.998 21.751H8.99805ZM14.248 17.251V15.751H15.748V17.251H14.248ZM7.49805 15.751V12.001C7.49805 11.5885 7.64492 11.2354 7.93867 10.9416C8.23242 10.6479 8.58555 10.501 8.99805 10.501H11.998V9.00098C11.998 8.58848 12.1449 8.23535 12.4387 7.9416C12.7324 7.64785 13.0855 7.50098 13.498 7.50098H16.498C16.9105 7.50098 17.2637 7.64785 17.5574 7.9416C17.8512 8.23535 17.998 8.58848 17.998 9.00098V10.501H20.998C21.4105 10.501 21.7637 10.6479 22.0574 10.9416C22.3512 11.2354 22.498 11.5885 22.498 12.001V15.751H17.248V14.251H12.748V15.751H7.49805ZM13.498 10.501H16.498V9.00098H13.498V10.501Z" fill="white"/>
                </g>
              </svg>
              }
            </span>
          </div>
          <div class="back-frame-mini-1-bottom">
            <div class="payment-part">
              <div class="payment-part-input-frame">
                <label for="sum-input">
                  <div class="input-frame-attached w-100">
                    <img src="assets/card-live-preview/dram.svg" alt="Dram icon" class="dram-style">
                     <input class="payment-input w-100" placeholder="{{ 'cards_by_qr.enter_the_amount' | translate }}" id="sum-input"
                           type="text"
                           [(ngModel)]="inputValue"
                           (input)="onPriceInput($event)"
                           (keypress)="onKeyPress($event)"
                           #inputElement
                           [readonly]="isInputReadOnly"
                    >
                  </div>
                  @if (errorMessage) {
                    <span class="err-mes"> {{ errorMessage }}</span>
                  }
                </label>
                @if (!isInputReadOnly) {
                  <div class="select-for-input-main">
                    @for (option of options; track option) {
                      <div class="select-for-input-option"
                           (click)="selectOption(option)"
                           [ngClass]="{ 'selected-option': isSelected(option) }">
                        {{ option }}
                      </div>
                    }
                  </div>
                }
              </div>
<!--              @if (!isInputReadOnly) {-->
<!--                <div class="commission-fee-container"-->
<!--                     [ngClass]="{'active': isCommissionFeeActive, 'inactive': !isCommissionFeeActive}">-->
<!--                  <span class="commission-fee-text" [ngClass]="{'inactive': !isCommissionFeeActive}">{{ 'cards_by_qr.full_amount_with_commission' | translate:{ percent: getCommission() } }}</span>-->
<!--                  <div class="term-toggle-container">-->
<!--                    <div class="term-toggle">-->
<!--                      <input type="checkbox" id="commissionFeeToggle" [(ngModel)]="isCommissionFeeActive"/>-->
<!--                      <label for="commissionFeeToggle"></label>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              }-->
              <div class="qr-or-share-line">
                <div class="share-section">
                  <p class="share-title">{{ 'cards_by_qr.share_with_friend' | translate }}</p>
                  <div class="share-buttons">
                    <button class="share-button qr-button" (click)="showQR(userCard.id, $event)">
                      <span class="button-icon">
                        <img src="/assets/svg/qr-icon.svg" alt="Qr Icon" width="24" height="24"/>
                      </span>
                      {{ 'individual_card.show_qr' | translate }}
                    </button>
                    <button class="share-button link-button" (click)="shareLink()">
                      <span class="button-icon">
                        <img src="/assets/svg/share-icon.svg" alt="Share Icon" width="24" height="24"/>
                      </span>
                      {{ 'cards_by_qr.share_link' | translate }}
                    </button>
                  </div>
                </div>
                <div class="divider">
                  <span class="divider-text">{{ 'cards_by_qr.or' | translate }}</span>
                </div>
              </div>
              <div class="payment-part-select-frame">
                <span class="tw-text">{{ 'cards_by_qr.transfer_with' | translate }}</span>
                <button class="w-100 pay-with-card" (click)="pay(PaymentMethod.NEW_CREDIT_CARD)">
                  <span class="size-controller">{{ 'payment.pay_with_new_credit_card' | translate }}</span>
                  <img src="assets/payment-type/credit-card.svg" alt="Credit Card" class="pay-with-card-icon">
                  <mat-icon class="plus-icon">add</mat-icon>
                </button>
                @if (creditCard && !userCard.isBusiness) {
                  <button class="w-100 pay-with-card" (click)="pay(PaymentMethod.EXISTING_CREDIT_CARD)">
                    <span class="size-controller">{{ 'cards_by_qr.credit_card_masked' | translate:{ digits: getCreditCardLastNumbers } }}</span>
                    <img src="assets/payment-type/credit-card.svg" alt="Credit Card" class="pay-with-card-icon">
                  </button>
                }
                <div class="payment-categories">
                  <button class="payment-cat-button" (click)="pay(PaymentMethod.APPLE_PAY)">
                    <img [src]="getLogoUrl('APPLE_PAY')" alt="Apple Pay">
                  </button>
                  <button class="payment-cat-button disabled">
                    <img [src]="getLogoUrl('GOOGLE_PAY')" alt="Google Pay">
                  </button>
                  <button class="payment-cat-button" (click)="pay(PaymentMethod.IDRAM)">
                    <img [src]="getLogoUrl('IDRAM')" alt="Idram">
                  </button>
                  <button class="payment-cat-button" (click)="redirectTelcellApp(TELCELL_PLACEHOLDER)">
                    <img [src]="getLogoUrl('TELCELL')" alt="Telcell">
                  </button>
                  <button class="payment-cat-button" (click)="pay(PaymentMethod.EASY_WALLET)">
                    <img [src]="getLogoUrl('EASY_WALLET')" alt="Easy Wallet">
                  </button>
                  <button class="payment-cat-button" (click)="pay(PaymentMethod.FASTSHIFT)">
                    <img [src]="getLogoUrl('FASTSHIFT')" alt="Fastshift">
                  </button>
                  <button class="payment-cat-button disabled">
                    <img [src]="getLogoUrl('INECO_PAY')" alt="Ineco Pay">
                  </button>
                  <button class="payment-cat-button" (click)="pay(PaymentMethod.MY_PAY)">
                    <img [src]="getLogoUrl('MY_PAY')" alt="My Pay" class="my-pay-button">
                  </button>
                  <button class="payment-cat-button disabled">
                    <img [src]="getLogoUrl('BANK_OF_GEORGIA')" alt="Bank of Georgia" class="image-height">
                  </button>
                  <button class="payment-cat-button disabled">
                    <img [src]="getLogoUrl('IO_MONEY')" alt="IO Money">
                  </button>
                  <button class="payment-cat-button disabled">
                    <img [src]="getLogoUrl('SBER_BANK')" alt="Sber Bank">
                  </button>
                  <button class="payment-cat-button disabled">
                    <img [src]="getLogoUrl('T_BANK')" alt="T Bank">
                  </button>
                </div>
              </div>
            </div>
            @if (!userCard.isBusiness) {
              <div class="back-frame-mini-4 w-100 mt-20px">
              <label class="back-frame-mini-1-line"></label>
              <button class="button-bottom" (click)="onCreateProfile()"><span class="button-bottom-inside">{{ 'cards_by_qr.create_my_own_profile' | translate }}</span>
              </button>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
